import * as React from 'react'

const Wheel3 = props => {
  return (
    <svg
      ref={props.wheelRef}
      viewBox="0 0 317 317"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M158.047 158.045L198.947 5.4043C224.891 12.3308 249.419 25.9647 269.771 46.3192L158.045 158.045H158.047ZM158.047 158.045L117.148 5.4043C91.2028 12.3308 66.6754 25.9647 46.3231 46.3192L158.049 158.045H158.047ZM198.949 310.686C224.894 303.76 249.421 290.124 269.773 269.772L158.047 158.045L198.947 310.686H198.949ZM310.688 198.945C317.834 172.181 317.834 143.908 310.688 117.146L158.047 158.045L310.688 198.945ZM158.047 158.045L5.40603 117.146C-1.73951 143.91 -1.73951 172.183 5.40603 198.945L158.047 158.045ZM46.3231 269.772C66.6776 290.126 91.2028 303.762 117.15 310.686L158.049 158.045L46.3231 269.772Z"
        fill="url(#paint0_linear_7794_19141)"
      />
      <path
        d="M158.047 158.045L117.148 5.40407C143.912 -1.74146 172.185 -1.74146 198.949 5.40407L158.049 158.045H158.047ZM158.047 158.045L269.773 269.771C290.128 249.417 303.764 224.892 310.688 198.947L158.047 158.047V158.045ZM158.047 158.045L310.688 117.146C303.762 91.2009 290.128 66.6734 269.773 46.3189L158.047 158.045ZM46.3233 46.3189C25.9688 66.6734 12.3349 91.1987 5.40844 117.146L158.049 158.045L46.3233 46.3189ZM5.40625 198.945C12.3327 224.889 25.9666 249.417 46.3211 269.769L158.047 158.043L5.40625 198.942V198.945ZM158.047 158.045L117.148 310.686C143.912 317.832 172.185 317.832 198.947 310.686L158.047 158.045Z"
        fill="url(#paint1_linear_7794_19141)"
      />
      <g style={{ mixBlendMode: 'screen' }} opacity="0.8">
        <path
          d="M54.623 217.759L61.4948 210.125L56.3601 201.232L65.7422 205.409L72.6139 197.777L71.5406 207.992L80.9226 212.169L70.8768 214.303L69.8035 224.517L64.6688 215.624L54.623 217.759Z"
          stroke="#00D5D4"
          strokeWidth="1.46109"
          strokeMiterlimit="10"
        />
        <path
          d="M261.473 98.3342L251.428 100.47L246.293 91.5742L245.22 101.789L235.174 103.924L244.556 108.102L243.483 118.316L250.354 110.682L259.736 114.86L254.602 105.966L261.473 98.3342Z"
          stroke="#00D5D4"
          strokeWidth="1.46109"
          strokeMiterlimit="10"
        />
        <path
          d="M54.623 98.3342L64.6688 100.47L69.8035 91.5742L70.8768 101.789L80.9226 103.924L71.5406 108.102L72.6139 118.316L65.7422 110.682L56.3601 114.86L61.4948 105.966L54.623 98.3342Z"
          stroke="#00D5D4"
          strokeWidth="1.46109"
          strokeMiterlimit="10"
        />
        <path
          d="M261.473 217.759L254.602 210.125L259.736 201.232L250.354 205.409L243.483 197.777L244.556 207.992L235.174 212.169L245.22 214.303L246.293 224.517L251.428 215.624L261.473 217.759Z"
          stroke="#00D5D4"
          strokeWidth="1.46109"
          strokeMiterlimit="10"
        />
        <path
          d="M158.047 38.6172L161.221 48.3848H171.492L163.184 54.4219L166.356 64.1895L158.047 58.1524L149.738 64.1895L152.912 54.4219L144.604 48.3848H154.875L158.047 38.6172Z"
          stroke="#00D5D4"
          strokeWidth="1.46109"
          strokeMiterlimit="10"
        />
        <path
          d="M158.047 277.471L161.221 267.703H171.492L163.184 261.666L166.356 251.898L158.047 257.936L149.738 251.898L152.912 261.666L144.604 267.703H154.875L158.047 277.471Z"
          stroke="#00D5D4"
          strokeWidth="1.46109"
          strokeMiterlimit="10"
        />
      </g>
      <path
        style={{ mixBlendMode: 'multiply' }}
        d="M158.047 316.095C245.334 316.095 316.095 245.334 316.095 158.047C316.095 70.7602 245.334 0 158.047 0C70.7602 0 0 70.7602 0 158.047C0 245.334 70.7602 316.095 158.047 316.095Z"
        fill="url(#paint2_radial_7794_19141)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7794_19141"
          x1="97.0406"
          y1="59.8041"
          x2="225.288"
          y2="266.324"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#383E45" />
          <stop offset="0.68" stopColor="#1E272E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7794_19141"
          x1="81.727"
          y1="25.8541"
          x2="234.368"
          y2="290.236"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#00D5D4" />
          <stop offset="1" stopColor="#00999C" />
        </linearGradient>
        <radialGradient
          id="paint2_radial_7794_19141"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(158.047 158.047) scale(180.59)">
          <stop offset="0.82" stopColor="white" />
          <stop offset="0.83" stopColor="#F6F6F6" />
          <stop offset="0.85" stopColor="#DEDFE0" />
          <stop offset="0.86" stopColor="#B8BABC" />
          <stop offset="0.88" stopColor="#82868A" />
          <stop offset="0.91" stopColor="#383E45" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export default Wheel3
